<div class="layout-content mt-2">
   <div class="grid">
      <div class="col-12 flex justify-content-center">
         <p-table [value]="subsections" [reorderableColumns]="false" (onRowReorder)="rowReorder($event)">
            <ng-template pTemplate="header" let-columns>
               <tr>
                  <th style="width:3rem"></th>
                  <th><div class="flex align-items-center justify-content-center">{{ 'REORDER_SUBSECTIONS' | translate }}</div></th>
               </tr>
            </ng-template>
            <ng-template pTemplate="body" let-subsection let-columns="columns" let-index="rowIndex">
               <tr [pReorderableRow]="index">
                  <td>
                      <span class="pi cm-bars" pReorderableRowHandle></span>
                  </td>
                  <td>{{subsection.TitleIt}}</td>
               </tr>
            </ng-template>
         </p-table>
      </div>
   </div>

   <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
      <button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}" class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
      </button>
   </div>
</div>